import { render, staticRenderFns } from "./mainFormRisks.vue?vue&type=template&id=e36c30c8&"
import script from "./mainFormRisks.vue?vue&type=script&lang=js&"
export * from "./mainFormRisks.vue?vue&type=script&lang=js&"
import style0 from "./mainFormRisks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports